import React from "react";
import { Gauge, Square, LayoutGrid, Droplet, Mountain, BrickWall } from "lucide-react";
import Header from "@/reusable_sections/Header";
import PageHero from "@/components/PageHero";
import ServiceIntro from "@/components/service/ServiceIntro";
import ServiceCards, { ServiceCardItem } from "@/components/service/ServiceCards";
import ServiceQuoteSection from "@/components/service/ServiceQuoteSection";
import OtherServices from "@/components/service/OtherServices";
import CtaBand from "@/components/CtaBand";
import Footer from "@/reusable_sections/Footer";
import DrivewayQuoteForm from "./sections/GetAFreeQuote";
const DRIVEWAY_SERVICE_CARDS: ServiceCardItem[] = [{
  title: "Asphalt & Tarmac",
  description: "Cost-effective and highly durable tarmac driveways across Southampton, perfect for the British climate with quick installation and a smooth, resilient finish.",
  icon: Gauge,
  to: "/TarmacServicesPage"
}, {
  title: "Concrete (Plain & Stamped)",
  description: "Incredibly long-lasting and low maintenance. Available in various patterns and colours to mimic premium natural materials.",
  icon: Square
}, {
  title: "Block Paving",
  description: "Versatile and aesthetically pleasing block paving in Southampton. Individual blocks allow for easy localized repairs and highly customizable designs.",
  icon: LayoutGrid,
  to: "/BlockPavingPage"
}, {
  title: "Resin-Bound Gravel",
  description: "Permeable, weed-resistant, and visually stunning resin driveways in Southampton. Provides a smooth, puddle-free surface complying with SUDS regulations.",
  icon: Droplet,
  to: "/ResinboundPage"
}, {
  title: "Loose Gravel & Shingle",
  description: "An affordable, classic option that provides excellent drainage and added security with its distinct crunching sound underfoot.",
  icon: Mountain
}, {
  title: "Natural Stone Cobblestone",
  description: "Timeless elegance and unmatched durability. Adds significant curb appeal, character, and value to any traditional or modern home.",
  icon: BrickWall
}];
export default function DrivewayServicesPage() {
  return <div className="min-h-screen bg-background text-foreground flex flex-col">
      <Header />

      <PageHero breadcrumbLabel="Driveway Services" breadcrumbParent={{
      label: "Services",
      to: "/ServicesHubPage"
    }} eyebrow="OUR SERVICES" title="Driveway Services in Southampton" intro="Durable, stylish, and expertly installed driveways tailored to your property across Southampton, Hampshire & surrounding areas." imageSrc="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1662274/img/premium_driveway_installation.png" imageAlt="Driveway installation featuring modern block paving in Southampton by Firststop Roofing Ltd" actions />

      <ServiceIntro eyebrow="EXPERT OVERVIEW" heading="Expert Driveway Solutions in Southampton" paragraphs={["Transform your property's curb appeal with our trusted driveway services in Southampton, Hampshire & surrounding areas. As experienced roofing and property specialists in Southampton, we deliver high-quality surfacing options including durable asphalt, versatile concrete, elegant block paving, modern resin-bound systems, classic gravel, and stunning natural stone.", "Our dedicated team delivers flawless driveway installations across Southampton tailored to your home's unique style, using robust ground preparation, deep compacted sub-bases, and precision edge restraints for lasting performance."]} benefits={["Expert groundworks with fully compacted MOT type 1 sub-bases", "Comprehensive surfacing choices including block paving, resin & tarmac", "Durable, SUDS-compliant drainage and bespoke edge restraints"]} imageSrc="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1662274/img/premium_driveway_installation.png" imageAlt="Modern driveway installation in Southampton by Firststop Roofing Ltd" cta />

      <ServiceCards eyebrow="WHAT WE OFFER" heading="Our Driveway Services in Southampton" intro="Durable, stylish, and expertly installed driveways tailored to your Southampton home. We offer a wide range of materials to suit your aesthetic preferences and budget." items={DRIVEWAY_SERVICE_CARDS} columns={3} />

      <ServiceQuoteSection id="get-a-free-quote" eyebrow="GET A FREE QUOTE" heading="Get a Free Driveway Quote in Southampton" intro="Ready to transform your Southampton property? Fill out the form with your project details, and our expert team will provide you with a comprehensive, no-obligation estimate tailored to your specific needs." serviceName="Driveway Services in Southampton">
        <DrivewayQuoteForm />
      </ServiceQuoteSection>

      <OtherServices currentKey="driveway-services" count={4} />

      <CtaBand />

      <Footer />
    </div>;
}